import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PoTable from "../../Components/PoTable";
import PoCard from "../../Components/PoTable/PoCard";
import DashBoardLayout from "../../Layouts/DashboardLayout/DashBoardLayout";
import "./potable.css";
import PageLoader from "../../Models/Pageloader/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchPoStatus } from "../../Store/Actions/vendor_dashboard";

const PoTablePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const { dashboardPOStats: poStatusData, statsLoading: poStatusLoading, statsError: poStatusError } = useSelector((state) => state.VendorDashboardReducer);

  useEffect(() => {
    dispatch(fetchPoStatus());
  }, [dispatch]);

const getCount = (index,headerStats=false) => {
let keyName=headerStats?"currentYearStats":"overallStats"
  if (!poStatusData?.data?.[keyName] || !Array.isArray(poStatusData.data?.[keyName])) {
      return 0;
  }

  const data = poStatusData.data?.[keyName]
  
  if (index === 0) {
      return data.reduce((sum, item) => sum + (item.count || 0), 0);
  }
  const item = data.find(obj => obj.VmsStatus === index);
  return item ? item.count : 0;
};

  return (
    <DashBoardLayout>
      {(poStatusLoading)&& <PageLoader />}
      <div className="main-dashboard-body mb-3">
        <h3 className="vendor-dashboard-heading py-2 px-3">{t("PO")}</h3>
        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-4 col-md-6 py-3">
              <PoCard
                title={t("All")}
                more={"..."}
                count={poStatusLoading
                  ? 0
                  : poStatusError
                  ? 0
                  : getCount(0)}
              />
            </div>
            <div className="col-lg-4 col-md-6 py-3">
              <PoCard
                title={t("Confirming PO")}
                more={"..."}
                count={poStatusLoading
                  ? 0
                  : poStatusError
                  ? 0
                  : getCount(1)}
              />
            </div>
            <div className="col-lg-4 col-md-6 py-3">
              <PoCard
                title={t("Acknowledge")}
                more={"..."}
                count={poStatusLoading
                  ? 0
                  : poStatusError
                  ? 0
                  : getCount(2)}
              />
            </div>
          </div>
        </div>

        <div className="container-fluid mt-2 mb-5">
        {poStatusError ? (
            <div className="error-message">
              <p>{t("Error loading PO data")}</p>
            </div>
          ) : (
            <PoTable getCount={getCount} />
            
          )}

        </div>
      </div>
    </DashBoardLayout>
  );
};

export default PoTablePage;
